import "./Footer.css";
import '../../Style/font_responsive.css';
import { navigateToNewTabExternal, openInNewTab } from "../../Services/service";
import { t } from "i18next";
export default function Footer() {
  return (
    <div className='footer-eproduct'>
        <div className="col-md-12 col-start">
            <img src="/image/logo-phl-footer.svg" />
        </div>
        <div className='col-md-12 footer-list' style={{background: "url(/image/footer/footer-logo-left-footer.png) no-repeat left bottom"}}>
            <div className='col-footer-list'>
                <div className="col-title-footer-wrap">
                    <h2 className="title-footer">{t("footerproduct")}</h2>
                </div>

                <div className="col-title-footer-wrap">
                    <ul>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_PRODUCT_NEW_1)} title={t("footerproductnew1")}>{t("footerproductnew1")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_PRODUCT_NEW_2)} title={t("footerproductnew2")}>{t("footerproductnew2")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_PRODUCT_NEW_3)} title={t("footerproductnew3")}>{t("footerproductnew3")}</label>
                        </li>
                        {/* <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_PRODUCT_4)} title={t("footerproduct4")}>{t("footerproduct4")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_PRODUCT_5)} title={t("footerproduct5")}>{t("footerproduct5")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_PRODUCT_6)} title={t("footerproduct6")}>{t("footerproduct6")}</label>
                        </li> */}
                    </ul>
                </div>
            </div>
            <div className='col-footer-list'>
                <div className="col-title-footer-wrap">
                    <h2 className="title-footer">{t("footercs")}</h2>
                </div>

                <div className="col-title-footer-wrap">
                    <ul>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_CS_1)} title={t("footercs1")}>{t("footercs1")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_CS_2)} title={t("footercs2")}>{t("footercs2")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_CS_3)} title={t("footercs3")}>{t("footercs3")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_CS_4)} title={t("footercs4")}>{t("footercs4")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_CS_5)} title={t("footercs5")}>{t("footercs5")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_CS_6)} title={t("footercs6")}>{t("footercs6")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_CS_7)} title={t("footercs7")}>{t("footercs7")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_CS_8)} title={t("footercs8")}>{t("footercs8")}</label>
                        </li>
                    </ul>
                </div>
            </div>
            <div className='col-footer-list'>
                <div className="col-title-footer-wrap">
                    <h2 className="title-footer">{t("contact")}</h2>
                </div>

                <div className="col-title-footer-wrap">
                    <ul>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_CONTACT_1)} title={t("contactnew1")}>{t("contactnew1")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_CONTACT_1)} title={t("contact2")}>{t("contact2")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_CONTACT_2)} title={t("contactnew3")}>{t("contactnew3")}</label>
                        </li>
                        <li>
                            <label className="value-form desc-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_CONTACT_3)} title={t("contact4")}>{t("contact4")}</label>
                        </li>
                        <li>
                            <ul className="ul-img-footer">
                                <li>
                                    <img className="img-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_ICON_1)} src="/image/footer/phone-footer.png" />
                                </li>
                                <li>
                                    <img className="img-footer" onClick={()=> openInNewTab(process.env.REACT_APP_FOOTER_ICON_2)} src="/image/footer/facebook-footer.png" />
                                </li>
                                <li>
                                    <img className="img-footer" onClick={()=> navigateToNewTabExternal(process.env.REACT_APP_FOOTER_ICON_3)} src="/image/footer/email-footer.png" />
                                </li>
                                <li>
                                    <img className="img-footer" onClick={()=> openInNewTab(process.env.REACT_APP_FOOTER_ICON_4)} src="/image/footer/youtube-footer.png" />
                                </li>
                                <li>
                                    <img className="img-footer" onClick={()=> openInNewTab(process.env.REACT_APP_FOOTER_ICON_5)} src="/image/footer/mess-footer.png" />
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div className="bg-under-footer">
            <div className="col-md-6 col-start">
                <span className="under-desc-footer" style={{color: "#bfbfbf"}}>{t("copyright")}</span>
            </div>
            <div className="col-md-6 col-end">
                <span className="under-desc-footer" style={{color: "#bfbfbf", justifyContent: "right"}}>{t("copyrightpolicy")}</span>
            </div>
        </div>
    </div>
  );
}
